import React from 'react';

import PropTypes from 'prop-types';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import './ErrorList.scss';

const ErrorList = ({ errors }) => {
    if (!errors || errors.length === 0) {
        return null;
    }

    return (
        <Row className="errors-block border">
            <Col md={12} className="text-danger p-3">
                <ol>
                    {
                        errors.map((error) => (
                            <li key={`${error.type}-${error.message}`}>
                                <b>{error.type}</b> {error.message}
                            </li>
                        ))
                    }
                </ol>
            </Col>
        </Row>
    );
};

ErrorList.propTypes = {
    errors: PropTypes.array.isRequired,
};

export default ErrorList;

